var exports = {
  "kL": "UploadSlotInfo.module__container___OU1tdm",
  "wx": "UploadSlotInfo.module__header___OU1tdm",
  "DD": "UploadSlotInfo.module__title___OU1tdm",
  "M1": "UploadSlotInfo.module__stats___OU1tdm",
  "h_": "UploadSlotInfo.module__description___OU1tdm",
  "Kk": "UploadSlotInfo.module__icon___OU1tdm",
  "wF": "UploadSlotInfo.module__uploadButtonDesktop___OU1tdm",
  "Ig": "UploadSlotInfo.module__uploadButtonMobile___OU1tdm",
};

module.exports = exports;
